module.exports = __webpack_public_path__ + "assets/img/portal_bg_two.d84a885f.png";